import React, { useState, useEffect } from "react";
import { InternationalTradeData, InternationalTradeType } from "./models/IntTradeData";
import { InternationalTradeCategory } from "./models/IntTradeCategory";
import { InternationalTradeSubCategory } from "./models/IntTradeSubCategory";
import { InternationalTradeRegion } from "./models/IntTradeRegion";
import { InternationalTradeCountry } from "./models/IntTradeCountry";
import { getAll } from ".";
import { sortBy } from "../../utils/array";
import Loading from "../../components/Loading/Loading";
import InternationalTrade from "./InternationalTrade";

type DataState = {
    datapoints: InternationalTradeData[];
    categories: InternationalTradeCategory[];
    subcategories: InternationalTradeSubCategory[];
    regions: InternationalTradeRegion[];
    countries: InternationalTradeCountry[];
};

function InternationalTradeContainer() {
    const [data, setData] = useState<DataState>({
        datapoints: [],
        categories: [],
        subcategories: [],
        regions: [],
        countries: []
    });

    useEffect(() => {
        getAll().then(([datapoints, categories, subcategories, regions, countries]) => {
            datapoints = sortBy(
                datapoints.filter(d => d.type === InternationalTradeType.export),
                d => d.year as number
            );

            setData({
                datapoints,
                categories,
                subcategories,
                regions,
                countries
            });
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (data.datapoints.length === 0) {
        return <Loading />;
    }

    return (
        <InternationalTrade data={data} />
    );
}

export default InternationalTradeContainer;
